import { Link } from "react-router-dom";
import caldeiraLogo from "@/assets/caldeira-logo.png";

const sections = [
  {
    title: "1. Termos de Uso",
    content: [
      "A plataforma Caldeira AI é uma ferramenta interna do Instituto Caldeira, destinada exclusivamente ao uso profissional por colaboradores e parceiros autorizados.",
      "O acesso é restrito a usuários com contas corporativas aprovadas. É proibido compartilhar credenciais de acesso, utilizar a plataforma para fins pessoais não relacionados ao trabalho, ou permitir o acesso de terceiros não autorizados.",
      "O uso indevido da plataforma poderá resultar na suspensão ou revogação do acesso, conforme as políticas internas do Instituto Caldeira.",
    ],
  },
  {
    title: "2. Coleta de Dados",
    content: [
      "Para o funcionamento da plataforma, coletamos os seguintes dados:",
      "• Nome completo e e-mail corporativo (via autenticação Google SSO);\n• Foto de perfil (avatar do Google);\n• Histórico de conversas realizadas com os modelos de IA;\n• Documentos enviados à base de conhecimento dos projetos;\n• Logs de acesso e sessões (data, horário, navegador utilizado).",
    ],
  },
  {
    title: "3. Finalidade do Tratamento",
    content: [
      "Os dados coletados são utilizados para as seguintes finalidades:",
      "• Personalização da experiência do usuário na plataforma;\n• Funcionamento do chat com modelos de inteligência artificial;\n• Gestão de permissões, times e projetos;\n• Auditoria de uso e geração de métricas internas;\n• Melhoria contínua dos serviços oferecidos.",
    ],
  },
  {
    title: "4. Compartilhamento de Dados",
    content: [
      "Os dados pessoais dos usuários não são compartilhados com terceiros, exceto com provedores de modelos de IA (via OpenRouter) para o processamento das mensagens de chat.",
      "Importante: as mensagens enviadas aos modelos de IA não contêm dados pessoais identificáveis do usuário (como nome ou e-mail). Apenas o conteúdo textual da conversa é transmitido para processamento.",
    ],
  },
  {
    title: "5. Armazenamento e Segurança",
    content: [
      "Todos os dados são armazenados em infraestrutura segura fornecida pelo Supabase, com as seguintes medidas de proteção:",
      "• Comunicação criptografada via HTTPS/TLS;\n• Autenticação segura via Google SSO (Single Sign-On);\n• Políticas de controle de acesso em nível de linha (Row Level Security);\n• Restrição de acesso por domínio de e-mail corporativo;\n• Logs de auditoria para rastreabilidade de ações.",
    ],
  },
  {
    title: "6. Direitos do Titular (LGPD)",
    content: [
      "Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você possui os seguintes direitos:",
      "• Acesso aos seus dados pessoais armazenados na plataforma;\n• Correção de dados incompletos, inexatos ou desatualizados;\n• Exclusão dos seus dados pessoais;\n• Portabilidade dos dados (exportação de conversas e informações);\n• Revogação do consentimento a qualquer momento.",
      "O exercício desses direitos pode ser feito através do painel de configurações da sua conta ou por contato direto com o administrador da plataforma.",
    ],
  },
  {
    title: "7. Retenção de Dados",
    content: [
      "Os dados pessoais são mantidos enquanto a conta do usuário estiver ativa na plataforma.",
      "Após a exclusão da conta, todos os dados pessoais associados serão removidos permanentemente em até 30 dias corridos, incluindo histórico de conversas, documentos enviados e logs de acesso.",
    ],
  },
  {
    title: "8. Contato",
    content: [
      "Para questões relacionadas à privacidade e proteção de dados, entre em contato com o responsável:",
      "📧 privacidade@institutocaldeira.org",
    ],
  },
];

export default function PrivacyPolicyPage() {
  const lastUpdated = new Date().toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="min-h-screen bg-secondary">
      <div className="max-w-3xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <img src={caldeiraLogo} alt="Instituto Caldeira" className="h-8" />
          <Link
            to="/login"
            className="text-sm text-brand-primary hover:underline"
          >
            ← Voltar ao login
          </Link>
        </div>

        {/* Title */}
        <div className="bg-surface border border-color rounded-xl p-8 md:p-10 space-y-8">
          <div>
            <h1 className="text-2xl font-bold text-primary mb-2">
              Política de Privacidade e Termos de Uso
            </h1>
            <p className="text-sm text-tertiary">
              Plataforma Caldeira AI — Instituto Caldeira
            </p>
          </div>

          {/* Sections */}
          {sections.map((section) => (
            <div key={section.title} className="space-y-3">
              <h2 className="text-lg font-semibold text-primary">
                {section.title}
              </h2>
              {section.content.map((paragraph, i) => (
                <p
                  key={i}
                  className="text-sm text-secondary leading-relaxed whitespace-pre-line"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          ))}

          {/* Footer */}
          <div className="pt-6 border-t border-color">
            <p className="text-xs text-tertiary">
              Última atualização: {lastUpdated}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
